import { Diamond } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { CATEGORIES } from "../constants";

const Marquee = () => {
  const { t } = useLanguage();
  const items = [t("slogan"), ...CATEGORIES.map((c) => t(`categories.${c}`)), t("tagline"), t("nodeposit.title")];
  const row = [...items, ...items];

  return (
    <div
      data-testid="slogan-marquee"
      className="relative overflow-hidden border-y border-gold/10 bg-[#0b0b0f] py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-8 hover:[animation-play-state:paused]">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="whitespace-nowrap font-display text-lg font-medium uppercase tracking-[0.25em] text-slate-400">
              {item}
            </span>
            <Diamond className="h-3 w-3 fill-gold/60 text-gold/60" aria-hidden="true" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 start-0 w-24 bg-gradient-to-r from-[#0b0b0f] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 end-0 w-24 bg-gradient-to-l from-[#0b0b0f] to-transparent" />
    </div>
  );
};

export default Marquee;
